module.exports = __webpack_public_path__ + "img/CS_Logo_Primary_RGB.ec9d9e63.png";